// Explicit stage-title fallbacks for generic Journeys that reuse older translated
// narratives whose locale resources pre-date stage-level title/description blocks.
// Descriptions reuse the first sentence of the already translated rich
// "What happens here?" content in genericJourneyStageLocalization.js.
const STAGE_KEYS = Object.freeze([
  "day-surgery|before",
  "day-surgery|procedure-recovery",
  "day-surgery|home",
  "outpatients|before",
  "outpatients|clinic",
  "outpatients|after",
  "emergency-department|arrival",
  "emergency-department|assessment-treatment",
  "emergency-department|next",
  "imaging-diagnostics|before",
  "imaging-diagnostics|visit",
  "imaging-diagnostics|results",
  "inpatient-ward|settling-in",
  "inpatient-ward|ward-care",
  "inpatient-ward|leaving",
  "critical-care-visitor|arriving",
  "critical-care-visitor|updates",
  "critical-care-visitor|next",
  "surgery-operation|preparing",
  "surgery-operation|operation-day",
  "surgery-operation|recovery",
  "inpatient-admission|before-admission",
  "inpatient-admission|during-stay",
  "inpatient-admission|leaving-hospital",
  "cancer-care|understanding-team",
  "cancer-care|assessment-treatment",
  "cancer-care|support-follow-up",
  "paediatrics|preparing",
  "paediatrics|during-visit",
  "paediatrics|going-home"
]);

const TITLES = Object.freeze({
  "ar": [
    "قبل وصولك",
    "الإجراء والتعافي",
    "العودة إلى المنزل",
    "قبل موعدك",
    "في العيادة",
    "بعد موعدك",
    "الوصول والتقييم الأولي",
    "التقييم والعلاج",
    "ماذا يحدث بعد ذلك",
    "قبل الفحص",
    "أثناء زيارتك",
    "النتائج والمتابعة",
    "الاستقرار في الجناح",
    "رعايتك في الجناح",
    "التخطيط لمغادرة المستشفى",
    "الوصول والتعرّف على المكان",
    "التحديثات والدعم",
    "ماذا يحدث بعد ذلك",
    "الاستعداد للجراحة",
    "يوم العملية",
    "التعافي والعودة إلى المنزل",
    "قبل الدخول إلى المستشفى",
    "أثناء إقامتك",
    "مغادرة المستشفى",
    "التعرّف على فريقك",
    "التقييم والعلاج",
    "الدعم والمتابعة",
    "الاستعداد للزيارة",
    "أثناء الزيارة أو الإقامة",
    "العودة إلى المنزل والمتابعة"
  ],
  "bn": [
    "আপনি পৌঁছানোর আগে",
    "প্রক্রিয়া ও সুস্থ হয়ে ওঠা",
    "বাড়ি ফেরা",
    "আপনার অ্যাপয়েন্টমেন্টের আগে",
    "ক্লিনিকে",
    "আপনার অ্যাপয়েন্টমেন্টের পরে",
    "আগমন ও প্রাথমিক মূল্যায়ন",
    "মূল্যায়ন ও চিকিৎসা",
    "এরপর কী হয়",
    "আপনার পরীক্ষার আগে",
    "আপনার ভিজিটের সময়",
    "ফলাফল ও ফলো-আপ",
    "ওয়ার্ডে এসে স্থির হওয়া",
    "ওয়ার্ডে আপনার যত্ন",
    "হাসপাতাল ছাড়ার পরিকল্পনা",
    "পৌঁছানো ও পরিবেশের সঙ্গে পরিচিত হওয়া",
    "আপডেট ও সহায়তা",
    "এরপর কী হয়",
    "অস্ত্রোপচারের প্রস্তুতি",
    "আপনার অস্ত্রোপচারের দিন",
    "সুস্থ হয়ে ওঠা ও বাড়ি ফেরা",
    "ভর্তির আগে",
    "হাসপাতালে থাকার সময়",
    "হাসপাতাল ছাড়া",
    "আপনার দলকে জানা",
    "মূল্যায়ন ও চিকিৎসা",
    "সহায়তা ও ফলো-আপ",
    "ভিজিটের প্রস্তুতি",
    "ভিজিট বা থাকার সময়",
    "বাড়ি ফেরা ও ফলো-আপ"
  ],
  "es": [
    "Antes de llegar",
    "Intervención y recuperación",
    "Volver a casa",
    "Antes de su cita",
    "En la consulta",
    "Después de su cita",
    "Llegada y primera valoración",
    "Valoración y tratamiento",
    "Qué ocurre después",
    "Antes de su prueba",
    "Durante su visita",
    "Resultados y seguimiento",
    "Instalarse en la planta",
    "Sus cuidados en la planta",
    "Planificar la salida del hospital",
    "Llegada y orientación",
    "Información y apoyo",
    "Qué ocurre después",
    "Preparación para la cirugía",
    "El día de su operación",
    "Recuperación y vuelta a casa",
    "Antes del ingreso",
    "Durante su estancia",
    "Salida del hospital",
    "Conocer a su equipo",
    "Valoración y tratamiento",
    "Apoyo y seguimiento",
    "Preparación para la visita",
    "Durante la visita o estancia",
    "Vuelta a casa y seguimiento"
  ],
  "fa": [
    "پیش از رسیدن",
    "اقدام درمانی و بهبودی",
    "بازگشت به خانه",
    "پیش از نوبت شما",
    "در درمانگاه",
    "پس از نوبت شما",
    "ورود و ارزیابی اولیه",
    "ارزیابی و درمان",
    "بعد چه اتفاقی می‌افتد",
    "پیش از آزمایش",
    "در طول مراجعه",
    "نتایج و پیگیری",
    "استقرار در بخش",
    "مراقبت شما در بخش",
    "برنامه‌ریزی برای ترک بیمارستان",
    "ورود و آشنایی با محیط",
    "به‌روزرسانی‌ها و حمایت",
    "بعد چه اتفاقی می‌افتد",
    "آماده شدن برای جراحی",
    "روز عمل شما",
    "بهبودی و بازگشت به خانه",
    "پیش از بستری شدن",
    "در طول بستری",
    "ترک بیمارستان",
    "آشنایی با تیم شما",
    "ارزیابی و درمان",
    "حمایت و پیگیری",
    "آماده شدن برای مراجعه",
    "در طول مراجعه یا بستری",
    "بازگشت به خانه و پیگیری"
  ],
  "fr": [
    "Avant votre arrivée",
    "Intervention et récupération",
    "Retour à domicile",
    "Avant votre rendez-vous",
    "À la consultation",
    "Après votre rendez-vous",
    "Arrivée et première évaluation",
    "Évaluation et traitement",
    "Ce qui se passe ensuite",
    "Avant votre examen",
    "Pendant votre visite",
    "Résultats et suivi",
    "Installation dans le service",
    "Vos soins dans le service",
    "Préparer votre sortie de l’hôpital",
    "Arrivée et découverte du service",
    "Informations et soutien",
    "Ce qui se passe ensuite",
    "Préparation à la chirurgie",
    "Le jour de votre opération",
    "Récupération et retour à domicile",
    "Avant l’admission",
    "Pendant votre séjour",
    "Quitter l’hôpital",
    "Connaître votre équipe soignante",
    "Évaluation et traitement",
    "Soutien et suivi",
    "Préparer la visite",
    "Pendant la visite ou le séjour",
    "Retour à domicile et suivi"
  ],
  "gu": [
    "તમે પહોંચો તે પહેલાં",
    "પ્રક્રિયા અને સાજા થવું",
    "ઘરે જવું",
    "તમારી એપોઇન્ટમેન્ટ પહેલાં",
    "ક્લિનિકમાં",
    "તમારી એપોઇન્ટમેન્ટ પછી",
    "આગમન અને પ્રારંભિક મૂલ્યાંકન",
    "મૂલ્યાંકન અને સારવાર",
    "આગળ શું થાય છે",
    "તમારી તપાસ પહેલાં",
    "તમારી મુલાકાત દરમિયાન",
    "પરિણામો અને અનુસરણ",
    "વોર્ડમાં સ્થિર થવું",
    "વોર્ડમાં તમારી સંભાળ",
    "હોસ્પિટલ છોડવાની યોજના",
    "આગમન અને પરિસ્થિતિથી પરિચિત થવું",
    "અપડેટ્સ અને સહાય",
    "આગળ શું થાય છે",
    "શસ્ત્રક્રિયા માટે તૈયારી",
    "તમારી શસ્ત્રક્રિયાનો દિવસ",
    "સાજા થવું અને ઘરે જવું",
    "દાખલ થવા પહેલાં",
    "તમારા રોકાણ દરમિયાન",
    "હોસ્પિટલ છોડવી",
    "તમારી ટીમને સમજવી",
    "મૂલ્યાંકન અને સારવાર",
    "સહાય અને અનુસરણ",
    "મુલાકાત માટે તૈયારી",
    "મુલાકાત અથવા રોકાણ દરમિયાન",
    "ઘરે જવું અને અનુસરણ"
  ],
  "it": [
    "Prima dell’arrivo",
    "Intervento e recupero",
    "Ritorno a casa",
    "Prima dell’appuntamento",
    "In ambulatorio",
    "Dopo l’appuntamento",
    "Arrivo e prima valutazione",
    "Valutazione e trattamento",
    "Cosa succede dopo",
    "Prima dell’esame",
    "Durante la visita",
    "Risultati e follow-up",
    "Sistemazione in reparto",
    "Le cure in reparto",
    "Pianificare la dimissione dall’ospedale",
    "Arrivo e conoscenza del reparto",
    "Aggiornamenti e supporto",
    "Cosa succede dopo",
    "Preparazione all’intervento",
    "Il giorno dell’intervento",
    "Recupero e ritorno a casa",
    "Prima del ricovero",
    "Durante il ricovero",
    "Dimissione dall’ospedale",
    "Conoscere il proprio team",
    "Valutazione e trattamento",
    "Supporto e follow-up",
    "Preparazione alla visita",
    "Durante la visita o il ricovero",
    "Ritorno a casa e follow-up"
  ],
  "pa": [
    "ਤੁਹਾਡੇ ਪਹੁੰਚਣ ਤੋਂ ਪਹਿਲਾਂ",
    "ਸਰਜਰੀ ਅਤੇ ਸਿਹਤਯਾਬੀ",
    "ਘਰ ਜਾਣਾ",
    "ਤੁਹਾਡੀ ਮੁਲਾਕਾਤ ਤੋਂ ਪਹਿਲਾਂ",
    "ਕਲੀਨਿਕ ਵਿੱਚ",
    "ਤੁਹਾਡੀ ਮੁਲਾਕਾਤ ਤੋਂ ਬਾਅਦ",
    "ਪਹੁੰਚ ਅਤੇ ਪਹਿਲਾ ਮੁਲਾਂਕਣ",
    "ਮੁਲਾਂਕਣ ਅਤੇ ਇਲਾਜ",
    "ਅੱਗੇ ਕੀ ਹੁੰਦਾ ਹੈ",
    "ਤੁਹਾਡੀ ਜਾਂਚ ਤੋਂ ਪਹਿਲਾਂ",
    "ਤੁਹਾਡੀ ਮੁਲਾਕਾਤ ਦੌਰਾਨ",
    "ਨਤੀਜੇ ਅਤੇ ਫਾਲੋ-ਅੱਪ",
    "ਵਾਰਡ ਵਿੱਚ ਪਹੁੰਚਣਾ",
    "ਵਾਰਡ ਵਿੱਚ ਤੁਹਾਡੀ ਦੇਖਭਾਲ",
    "ਹਸਪਤਾਲ ਛੱਡਣ ਦੀ ਯੋਜਨਾ",
    "ਪਹੁੰਚ ਅਤੇ ਥਾਂ ਨਾਲ ਜਾਣ-ਪਛਾਣ",
    "ਅੱਪਡੇਟ ਅਤੇ ਸਹਾਇਤਾ",
    "ਅੱਗੇ ਕੀ ਹੁੰਦਾ ਹੈ",
    "ਸਰਜਰੀ ਲਈ ਤਿਆਰੀ",
    "ਤੁਹਾਡੀ ਸਰਜਰੀ ਦਾ ਦਿਨ",
    "ਸਿਹਤਯਾਬੀ ਅਤੇ ਘਰ ਜਾਣਾ",
    "ਦਾਖਲੇ ਤੋਂ ਪਹਿਲਾਂ",
    "ਤੁਹਾਡੇ ਰਹਿਣ ਦੌਰਾਨ",
    "ਹਸਪਤਾਲ ਛੱਡਣਾ",
    "ਆਪਣੀ ਟੀਮ ਨੂੰ ਜਾਣਨਾ",
    "ਮੁਲਾਂਕਣ ਅਤੇ ਇਲਾਜ",
    "ਸਹਾਇਤਾ ਅਤੇ ਫਾਲੋ-ਅੱਪ",
    "ਮੁਲਾਕਾਤ ਲਈ ਤਿਆਰੀ",
    "ਮੁਲਾਕਾਤ ਜਾਂ ਰਹਿਣ ਦੌਰਾਨ",
    "ਘਰ ਜਾਣਾ ਅਤੇ ਫਾਲੋ-ਅੱਪ"
  ],
  "pl": [
    "Przed przyjazdem",
    "Zabieg i powrót do zdrowia",
    "Powrót do domu",
    "Przed wizytą",
    "W poradni",
    "Po wizycie",
    "Przyjęcie i wstępna ocena",
    "Ocena i leczenie",
    "Co dzieje się dalej",
    "Przed badaniem",
    "Podczas wizyty",
    "Wyniki i dalsza opieka",
    "Rozpoczęcie pobytu na oddziale",
    "Opieka na oddziale",
    "Planowanie wyjścia ze szpitala",
    "Przybycie i zapoznanie z oddziałem",
    "Informacje i wsparcie",
    "Co dzieje się dalej",
    "Przygotowanie do operacji",
    "Dzień operacji",
    "Powrót do zdrowia i do domu",
    "Przed przyjęciem",
    "Podczas pobytu",
    "Wyjście ze szpitala",
    "Poznaj swój zespół",
    "Ocena i leczenie",
    "Wsparcie i dalsza opieka",
    "Przygotowanie do wizyty",
    "Podczas wizyty lub pobytu",
    "Powrót do domu i dalsza opieka"
  ],
  "pt": [
    "Antes de chegar",
    "Intervenção e recuperação",
    "Regresso a casa",
    "Antes da consulta",
    "Na consulta",
    "Depois da consulta",
    "Chegada e primeira avaliação",
    "Avaliação e tratamento",
    "O que acontece a seguir",
    "Antes do exame",
    "Durante a visita",
    "Resultados e acompanhamento",
    "Chegada ao serviço",
    "Os seus cuidados no serviço",
    "Planear a saída do hospital",
    "Chegada e conhecer a unidade",
    "Atualizações e apoio",
    "O que acontece a seguir",
    "Preparação para a cirurgia",
    "O dia da operação",
    "Recuperação e regresso a casa",
    "Antes do internamento",
    "Durante o internamento",
    "Saída do hospital",
    "Conhecer a sua equipa",
    "Avaliação e tratamento",
    "Apoio e acompanhamento",
    "Preparação para a visita",
    "Durante a visita ou internamento",
    "Regresso a casa e acompanhamento"
  ],
  "ro": [
    "Înainte de sosire",
    "Intervenția și recuperarea",
    "Întoarcerea acasă",
    "Înainte de programare",
    "La consultație",
    "După programare",
    "Sosirea și evaluarea inițială",
    "Evaluare și tratament",
    "Ce urmează",
    "Înainte de investigație",
    "În timpul vizitei",
    "Rezultate și urmărire",
    "Sosirea pe secție",
    "Îngrijirea dumneavoastră pe secție",
    "Planificarea externării",
    "Sosirea și familiarizarea cu secția",
    "Actualizări și sprijin",
    "Ce urmează",
    "Pregătirea pentru operație",
    "Ziua operației",
    "Recuperarea și întoarcerea acasă",
    "Înainte de internare",
    "În timpul internării",
    "Părăsirea spitalului",
    "Cunoașterea echipei dumneavoastră",
    "Evaluare și tratament",
    "Sprijin și urmărire",
    "Pregătirea pentru vizită",
    "În timpul vizitei sau internării",
    "Întoarcerea acasă și urmărirea"
  ],
  "so": [
    "Ka hor intaadan iman",
    "Habraaca iyo soo kabashada",
    "Guriga aadista",
    "Ka hor ballantaada",
    "Rugta caafimaadka",
    "Ballantaada ka dib",
    "Imaatinka iyo qiimaynta koowaad",
    "Qiimayn iyo daaweyn",
    "Maxaa xiga",
    "Ka hor baaritaankaaga",
    "Inta lagu jiro booqashadaada",
    "Natiijooyinka iyo dabagalka",
    "La qabsiga qaybta",
    "Daryeelkaaga qaybta",
    "Qorshaynta ka bixidda isbitaalka",
    "Imaatinka iyo barashada deegaanka",
    "Warbixinno iyo taageero",
    "Maxaa xiga",
    "U diyaar garowga qalliinka",
    "Maalinta qalliinkaaga",
    "Soo kabashada iyo guriga aadista",
    "Ka hor gelitaanka isbitaalka",
    "Inta aad isbitaalka joogto",
    "Ka bixidda isbitaalka",
    "Barashada kooxdaada",
    "Qiimayn iyo daaweyn",
    "Taageero iyo dabagal",
    "U diyaar garowga booqashada",
    "Inta lagu jiro booqashada ama joogitaanka",
    "Guriga aadista iyo dabagalka"
  ],
  "tl": [
    "Bago ka dumating",
    "Operasyon at paggaling",
    "Pag-uwi",
    "Bago ang iyong appointment",
    "Sa clinic",
    "Pagkatapos ng iyong appointment",
    "Pagdating at unang pagsusuri",
    "Pagsusuri at paggamot",
    "Ano ang susunod na mangyayari",
    "Bago ang iyong pagsusuri",
    "Habang nasa iyong pagbisita",
    "Mga resulta at follow-up",
    "Pagdating sa ward",
    "Ang iyong pangangalaga sa ward",
    "Pagpaplano sa paglabas ng ospital",
    "Pagdating at pagkilala sa unit",
    "Mga update at suporta",
    "Ano ang susunod na mangyayari",
    "Paghahanda para sa operasyon",
    "Araw ng iyong operasyon",
    "Paggaling at pag-uwi",
    "Bago ma-admit",
    "Habang naka-admit",
    "Paglabas ng ospital",
    "Pagkilala sa iyong care team",
    "Pagsusuri at paggamot",
    "Suporta at follow-up",
    "Paghahanda para sa pagbisita",
    "Habang bumibisita o naka-admit",
    "Pag-uwi at follow-up"
  ],
  "tr": [
    "Gelmeden önce",
    "İşlem ve iyileşme",
    "Eve dönüş",
    "Randevunuzdan önce",
    "Klinikte",
    "Randevunuzdan sonra",
    "Geliş ve ilk değerlendirme",
    "Değerlendirme ve tedavi",
    "Sonra ne olur",
    "Tetkikinizden önce",
    "Ziyaretiniz sırasında",
    "Sonuçlar ve takip",
    "Servise yerleşme",
    "Servisteki bakımınız",
    "Hastaneden ayrılmayı planlama",
    "Geliş ve ortama alışma",
    "Güncellemeler ve destek",
    "Sonra ne olur",
    "Ameliyata hazırlanma",
    "Ameliyat gününüz",
    "İyileşme ve eve dönüş",
    "Yatıştan önce",
    "Yatışınız sırasında",
    "Hastaneden ayrılma",
    "Ekibinizi tanıma",
    "Değerlendirme ve tedavi",
    "Destek ve takip",
    "Ziyarete hazırlanma",
    "Ziyaret veya yatış sırasında",
    "Eve dönüş ve takip"
  ],
  "ur": [
    "آپ کے پہنچنے سے پہلے",
    "طریقۂ کار اور صحت یابی",
    "گھر جانا",
    "آپ کی ملاقات سے پہلے",
    "کلینک میں",
    "آپ کی ملاقات کے بعد",
    "آمد اور ابتدائی جائزہ",
    "جائزہ اور علاج",
    "آگے کیا ہوتا ہے",
    "آپ کے ٹیسٹ سے پہلے",
    "آپ کے دورے کے دوران",
    "نتائج اور فالو اَپ",
    "وارڈ میں پہنچنا",
    "وارڈ میں آپ کی نگہداشت",
    "ہسپتال چھوڑنے کی منصوبہ بندی",
    "آمد اور ماحول سے واقفیت",
    "تازہ معلومات اور مدد",
    "آگے کیا ہوتا ہے",
    "آپریشن کی تیاری",
    "آپ کے آپریشن کا دن",
    "صحت یابی اور گھر جانا",
    "داخلے سے پہلے",
    "آپ کے قیام کے دوران",
    "ہسپتال سے روانگی",
    "اپنی ٹیم کو جاننا",
    "جائزہ اور علاج",
    "مدد اور فالو اَپ",
    "دورے کی تیاری",
    "دورے یا قیام کے دوران",
    "گھر جانا اور فالو اَپ"
  ],
  "zh": [
    "到院前",
    "手术与恢复",
    "回家",
    "就诊前",
    "在门诊",
    "就诊后",
    "到达与初步评估",
    "评估与治疗",
    "接下来会发生什么",
    "检查前",
    "就诊期间",
    "结果与随访",
    "入住病房",
    "您在病房的护理",
    "安排离院",
    "到达与熟悉环境",
    "病情更新与支持",
    "接下来会发生什么",
    "手术准备",
    "手术当天",
    "恢复与回家",
    "入院前",
    "住院期间",
    "离开医院",
    "了解您的医疗团队",
    "评估与治疗",
    "支持与随访",
    "就诊准备",
    "就诊或住院期间",
    "回家与随访"
  ]
});

function buildStageTitleMap(values = []) {
  return Object.freeze(Object.fromEntries(STAGE_KEYS.map((key, index) => [key, values[index] || null])));
}

export const GENERIC_JOURNEY_STAGE_TITLE_TRANSLATIONS = Object.freeze(
  Object.fromEntries(Object.entries(TITLES).map(([locale, values]) => [locale, buildStageTitleMap(values)])),
);

export function getGenericJourneyStageTitleTranslation(language, journeyId, stageId) {
  const locale = String(language || '').toLowerCase().split('-')[0];
  const templateId = String(journeyId || '').replace(/^generic-/, '');
  return GENERIC_JOURNEY_STAGE_TITLE_TRANSLATIONS[locale]?.[`${templateId}|${stageId}`] || null;
}
